import { gql } from "@apollo/client";

const GET_TEMPLATES = gql`
  query getTemplates($companyId: String!) {
    whatsappTemplates(where: { companyId: $companyId }) {
      id
      name
      status
      type
      channelId
      category
      channel {
        id
        name
        providerId
      }
      components {
        format
        text
        exampleBody {
          body_text
        }
        exampleHeader {
          header_handle
        }
      }
    }
  }
`;

const GET_TEMPLATES_BY_CHANNEL_ID = gql`
  query getTemplates(
    $channelId: String!
    $name: String
    $skip: Int
    $first: Int
  ) {
    whatsappTemplates(
      where: {
        AND: [
          { channelId: $channelId }
          { name_contains: $name }
          { status: "accepted" }
        ]
      }
      orderBy: createdAt_DESC
      skip: $skip
      first: $first
    ) {
      id
      name
      status
      type
      channelId
      category
      channel {
        id
        name
        providerId
      }
      components {
        type
        format
        text
        exampleBody {
          body_text
        }
        exampleHeader {
          header_handle
        }
        buttons {
          type
          text
          url
          phone_number
          example
        }
      }
    }
  }
`;

const GET_TEMPLATE_BY_NAME_AND_CHANNEL = gql`
  query checkTemplateName($channelId: String!, $name: String!) {
    whatsappTemplates(
      where: {
        AND: [{ channelId: $channelId }, { name: $name }]
      }
      first: 1
    ) {
      id
      name
    }
  }
`;

const ApolloTemplates = {
  GET_TEMPLATES,
  GET_TEMPLATES_BY_CHANNEL_ID,
  GET_TEMPLATE_BY_NAME_AND_CHANNEL,
};

export default ApolloTemplates;
